import React from "react"
import PropTypes from "prop-types"
import { withRouter } from "react-router-dom"
import { Redirect } from "react-router-dom"
import ProviderFinderLayout, {
  Breadcrumbs,
  LocationLink,
  MultiColumnLayout
} from "components/views/providerfinder/ProviderFinderLayout"
import ProvidersByCountry from "content/Providers.json"
import L10n from "lib/carrot-l10n"
import { Spacer } from "../atoms/Atoms"
import { ProviderFinderSideBar } from "components/views/providerfinder/SideBar"
const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const Main = ({ country, subRegion, cities }) => {
  const cityArray = Object.keys(cities)

  const breadcrumbsList = [{ text: country, to: "/providerfinder" }, { text: subRegion }]

  const cityComponents = cityArray.map((city) => (
    <LocationLink key={city} name={city} to={`/providerfinder/${country}/${subRegion}/${city}`} />
  ))

  // if there is only one city in the list, add two <br> so that
  // the column layout makes three columns and puts the city on
  // the left
  if (cityArray.length === 1) {
    cityComponents.push([<br key="br1" />, <br key="br2" />])
  }

  return (
    <>
      <div>
        <Breadcrumbs list={breadcrumbsList} />
      </div>
      <Spacer height={1.5} />
      <MultiColumnLayout>{cityComponents}</MultiColumnLayout>
    </>
  )
}

const SubRegion = (props) => {
  const { country, subRegion } = props.match.params

  let cities
  try {
    cities = ProvidersByCountry[country][subRegion]
  } catch (caughtError) {
    return <Redirect to="/providerfinder" />
  }
  if (cities === undefined) {
    return <Redirect to="/providerfinder" />
  }

  return (
    <ProviderFinderLayout
      headerText={l`providerFinder`}
      main={<Main country={country} subRegion={subRegion} cities={cities} />}
      sideBar={<ProviderFinderSideBar />}
    />
  )
}

SubRegion.propTypes = {
  history: PropTypes.object.isRequired
}

export default withRouter(SubRegion)
